export default {
	/***********************************************菜单名称****************************************************/
	"制单管理": "制单管理",
	"扫菲报工": "扫菲报工",
	"手动报工": "手动报工",
	"每日工资": "每日工资",
	"工资详情": "工资详情",
	"小组工资": "小组工资",
	"裁床管理": "裁床管理",
	"裁片装箱": "裁片装箱",
	"汇报记录": "汇报记录",
	"外发管理": "外发管理",
	"裁床收料": "裁床收料",
	"供应商管理": "供应商管理",
	"客户管理": "客户管理",
	"基础管理": "基础管理",
	"选择菲票":"选择菲票",
	"品质检验":"品质检验",
	"领料管理":"领料管理",
	"松布管理":"松布管理",
	"松布幅宽":"松布幅宽",
	"拉布管理":"拉布管理",
	

	/***********************************************登录页****************************************************/
	"登录": "登录",
	"欢迎登录": "欢迎登录",
	"请输入手机号": "请输入手机号",
	"请输入密码": "请输入密码",

	/***********************************************首页home**************************************************/
	"切换语言": "切换语言",
	"退出": "退出",

	/***********************************************制单管理**************************************************/
	"待接单": '待接单',
	"准备中": "准备中",
	"进行中": "进行中",
	"已完成": "已完成",
	"已拒单": "已拒单",
	"请输入生产单号或款号": "请输入生产单号或款号",

	/***********************************************制单汇报详情***********************************************/
	"附件上传": "附件上传",
	"最多选择5个文件": "最多选择5个文件",
	"上传文件": "上传文件",

	/***********************************************手动报工**************************************************/
	"色码量": "色码量",

	/***********************************************扫菲报工**************************************************/
	"节点选择": "节点选择",
	"生产单号": "生产单号",
	"暂无": " 暂无",
	"菲票号": "菲票号",
	"制单数": "制单数",
	"扎号": "扎号",
	"总床次": "总床次",
	"色": "色",
	"码": " 码",
	"数量": " 数量",
	"清空": " 清空",
	"备注": " 备注",
	"当前已选择": "当前已选择",
	"总裁数": "总裁数",

	/***********************************************每日工资**************************************************/
	"提成": "提成",
	"件": "件",
	"元": "元",

	/***********************************************工资详情**************************************************/
	"月收入": "月收入",
	"年":"年",
	"月":"月",
	"日":"日",

	/***********************************************小组工资**************************************************/
	"汇总": "汇总",

	/***********************************************裁床管理**************************************************/
	"请输入裁床单号、款号或生产单号": "请输入裁床单号、款号或生产单号",
	"名称": "名称",
	"款号": "款号",
	"合同号": "合同号",
	"返回": "返回 ",
	"汇报": "汇报 ",
	"开始拉布": "开始拉布",
	"完成拉布": "完成拉布",
	"检片": "检片",

	/***********************************************裁片装箱*****************************************************/
	"请输入箱号": "请输入箱号",
	"共": "共",
	"扎": "扎",
	"片": "片",
	"裁床单号": "裁床单号",
	"已装箱": "已装箱",
	"未装箱": "未装箱",
	"部位": "部位",
	"确认装箱": "确认装箱",
	"颜色": "颜色",
	"尺码": " 尺码 ",
	"装箱详情": "装箱详情",

	/***********************************************汇报记录*****************************************************/
	"生产单号": "生产单号",
	"工厂款号": "工厂款号",
	"总床次": "总床次",
	"工序号/工序": "工序号/工序",
	"请输入编码、简码、简称": "请输入编码、简码、简称",
	"审核通过": "审核通过",
	"驳回": "驳回",
	"搜索": '搜索',
	"提示": "提示",
	"汇报删除记录": "汇报删除记录",

	/***********************************************外发********************************************************/
	"重新派单": "重新派单",
	"新增外发": "新增外发",

	/***********************************************外发详情*****************************************************/
	"订单数量": "订单数量",
	"订单单价": "订单单价",
	"派发公司": "派发公司",
	"交货日期": "交货日期",
	"派发备注": "派发备注",
	"拒单": "拒单",
	"接单": "接单",
	"订单详情": "订单详情",
	"请选择日期": "请选择日期",
	"请输入订单数量":"请输入订单数量",
	"请输入订单单价":"请输入订单单价",
	"请选择派发公司":"请选择派发公司",
	"请选择交货日期":"请选择交货日期",

	/***********************************************收料详情*****************************************************/
	"收料详情": "收料详情",

	/***********************************************供应商管理***************************************************/
	"编码": "编码",
	"类型": "类型",
	"正常": "正常",
	"停用": "停用",
	"待验厂": "待验厂",

	/***********************************************供应商详情***************************************************/
	"简码": "简码",
	"简称": "简称",
	"供应商分类": "供应商分类",
	"联系人": "联系人",
	"联系人电话": "联系人电话",
	"地址": "地址",
	"供应商详情": "供应商详情",

	/***********************************************客户管理***************************************************/
	"业务员": "业务员 ",
	"合作方式": "合作方式",
	"负责人": "负责人 ",
	"客户组别": "客户组别",
	"客户编号": "客户编号",
	"待审核": "待审核",
	"电话": "电话",
	"请输入名称": "请输入名称",
	"请输入简称": "请输入简称",
	"请输入负责人名称": "请输入负责人名称",
	"请输入负责人电话": "请输入负责人电话",
	"请输入客户组别": "请输入客户组别",
	"请输入客户编号": "请输入客户编号",
	"请输入地址": "请输入地址",
	"客户详情": "客户详情",
	
	/***********************************************品质检验***************************************************/
	"时间":"时间",
	"客户":"客户",
	"地址":"地址",
	"检验中":"检验中",
	"待接收":"待接收",
	"任务详情":"任务详情",
	"正在检验":"正在检验",
	"请按相应的检验要求和标准进行检验":"请按相应的检验要求和标准进行检验",
	"请按下面指定时间、地址，进行打卡":"请按下面指定时间、地址，进行打卡",
	"确认打卡":"确认打卡",
	"进入检验":"进入检验",
	"查看进度":"查看进度",
	"订单总数量":"订单总数量",
	"已完成数量":"已完成数量",
	"下单日期":"下单日期",
	"查货要求":"查货要求",
	"验货类型":"验货类型",
	"交货日期":"交货日期",
	"品类":"品类",
	"部位尺寸":"部位尺寸",
	"工艺说明":"工艺说明",

	
	
	
	/***********************************************领料管理***************************************************/
	"待提交":"待提交",
	"单据编号":"单据编号",
	"制造单号":"制造单号",
	"领料员":"领料员",
	"备料员":"备料员",
	"新增":"新增",
	"车间库位":"车间库位",
	"单件用量":"单件用量",
	"物料颜色":"物料颜色",
	"本卷数量":"本卷数量",
	"总数量":"总数量",
	"移除":"移除",
	"扫码":"扫码",
	"领料单详情":"领料单详情",
	
	
	

	

	/***********************************************按钮类*****************************************************/
	"查看订单": "查看订单",
	"确定完成": "确定完成",
	"扫描菲票": "扫描菲票",
	"节点汇报": "节点汇报",
	"删除": "删除",
	"新增外发": "新增外发",
	"启用": "启用",
	"停用": "停用",
	"确定修改": "确定修改",
	"确定":"确定",
	"取消":"取消",
	
	
	/***********************************************弹窗********************************************************/
	"是否确定删除": "是否确定删除",
	"已删除": "已删除",
	"暂无数据": '暂无数据',
	"全选":"全选",
	"忽略并提交":"忽略并提交",
	"该节点没有配置工序,请先在PC端配置工序":"该节点没有配置工序,请先在PC端配置工序",
	"轻触照亮":"轻触照亮",
	"将二维码放入框中，即可自动扫描":"将二维码放入框中，即可自动扫描"
	
	

}
